import {scaleLinear} from 'd3-scale'
const d3 = Object.assign({}, {scaleLinear})

const colorsArray = [
  ['#99cccd', '#67b3b3', '#34999a', '#018081', '#016667', '#014d4d', '#003334'],
  ['#c9bec4', '#ae9ea7', '#937d89', '#785d6c', '#604a56', '#483841', '#30252b'],
  ['#f9dba3', '#f6c974', '#f3b746', '#f0a518', '#c08413', '#90630e', '#60420a'],
  ['#f2b4ab', '#eb8e80', '#e56956', '#de432c', '#b23623', '#85281a', '#591b12'],
  ['#d7e9f1', '#c2dfe9', '#aed4e2', '#9ac9db', '#7ba1af', '#5c7983', '#3e5058'],
  ['#c3cbc8', '#a5b0ad', '#879691', '#697c76', '#54635e', '#3f4a47', '#2a322f'],
  ['#f4bbbc', '#ef9a9b', '#e97879', '#e45658', '#b64546', '#893435', '#5b2223']
]
const palette = colorsArray.map(colorArray =>
  d3
    .scaleLinear()
    .domain(colorArray.map((_, i) => i / (colorArray.length - 1)))
    .range(colorArray)
)
const colors = colorsArray.reduce((object, colorArray, i) => {
  object[`color${i}`] = colorArray[Math.floor(colorArray.length / 2)]
  return object
}, {})
// console.log(colors)
// colors: {
//   'color0': '#018081',
//   'color1': '#785d6c',
//   'color2': '#f0a518',
//   'color3': '#de432c',
//   'color4': '#9ac9db',
//   'color5': '#697c76',
//   'color6': '#e45658'
// }

const LIGHT_GRAY = '#efefef'
const GRAY = '#A7A7A7'

const fillMapper = (colorIndex, prop, options) => {
  let color
  if (!colorIndex) {
    color = options.isNotFromFeeds ? GRAY : LIGHT_GRAY
  } else {
    let value = 0.5
    if (options.shade) {
      const max = 0.5
      const min = -0.3
      value = max - (max - min) * prop
    }
    color = palette[colorIndex](value)
  }
  return color
}

export {palette, colors, fillMapper, LIGHT_GRAY}
